const ListEmailTemplates = () => import('@/domain/emailTemplates/ListEmailTemplates.vue')
const NewEmailTemplate = () => import('@/domain/emailTemplates/NewEmailTemplate.vue')
const EditEmailTemplate = () => import('@/domain/emailTemplates/EditEmailTemplate.vue')

export default [
  {
    path: 'email-templates',
    redirect: 'email-templates/list',
    name: 'event.emailTemplates',
    component: {
      render(c) {
        return c('router-view')
      }
    },
    meta: {
      label: 'Email Templates',
      breadcrumb: {
        to: { name: 'event.emailTemplates.list' },
        text: 'Email Templates'
      }
    },
    children: [
      {
        path: 'list',
        name: 'event.emailTemplates.list',
        component: ListEmailTemplates,
        meta: {
          scopeType: 'pica-service',
          permission: 'email_template.list',
          label: 'Email Templates'
        }
      },
      {
        path: 'new',
        name: 'event.emailTemplates.new',
        component: NewEmailTemplate,
        meta: {
          scopeType: 'pica-service',
          permission: 'email_template.create',
          label: 'Customize Email Template',
          breadcrumb: { text: 'Customize Template' }
        }
      },
      {
        path: ':emailType',
        name: 'event.emailTemplates.edit',
        component: EditEmailTemplate,
        meta: {
          scopeType: 'pica-service',
          permission: 'email_template.edit',
          label: 'Edit Email Template',
          breadcrumb: (context) => {
            const template = context.store.getters['emailTemplates/template']
            return {
              text: template ? template.email_type : 'Edit'
            }
          }
        }
      }
    ]
  }
]
